import { updatePreview as baseUpdatePreview } from './preview.js';
import * as state from './state.js';
import { scalePreviewContent } from './preview.js';

export function startConfetti() {
    const emojis = ['🎉', '🎊', '✨', '🎈', '🎁', '🏆', '⭐', '💫', '🌟', '🎯'];
    const confettiContainer = document.createElement('div');
    confettiContainer.id = 'confetti-container';
    confettiContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 9999;
        overflow: hidden;
    `;
    document.body.appendChild(confettiContainer);

    function createConfetti() {
        const emoji = emojis[Math.floor(Math.random() * emojis.length)];
        const confetti = document.createElement('div');
        confetti.textContent = emoji;
        confetti.style.cssText = `
            position: absolute;
            font-size: ${20 + Math.random() * 30}px;
            left: ${Math.random() * 100}%;
            top: -50px;
            animation: confetti-fall ${3 + Math.random() * 3}s linear forwards;
            pointer-events: none;
        `;
        confettiContainer.appendChild(confetti);

        setTimeout(() => {
            confetti.remove();
        }, 6000);
    }

    if (!document.getElementById('confetti-styles')) {
        const style = document.createElement('style');
        style.id = 'confetti-styles';
        style.textContent = `
            @keyframes confetti-fall {
                to {
                    transform: translateY(100vh) rotate(${360 + Math.random() * 360}deg);
                    opacity: 0;
                }
            }
        `;
        document.head.appendChild(style);
    }

    let confettiInterval = setInterval(createConfetti, 100);
    // Store on window so stopConfetti can clear it
    window._confettiInterval = confettiInterval;

    for (let i = 0; i < 50; i++) {
        setTimeout(() => createConfetti(), i * 50);
    }
}

export function stopConfetti() {
    if (window._confettiInterval) {
        clearInterval(window._confettiInterval);
        window._confettiInterval = null;
    }
    const container = document.getElementById('confetti-container');
    if (container) {
        container.remove();
    }
}

export function renderVegaCharts() {
    const chartDiv = document.getElementById('chart-revenue_chart');
    if (!chartDiv) return;

    const chartSpecJson = chartDiv.getAttribute('data-chart-spec');
    const chartDataJson = chartDiv.getAttribute('data-chart-data');

    if (!chartSpecJson || !chartDataJson || typeof window.vegaEmbed === 'undefined') return;

    try {
        const spec = JSON.parse(chartSpecJson);
        const allData = JSON.parse(chartDataJson);

        const initialData = allData.filter(d => d.revenue_type === 'Actual');
        spec.data = { values: initialData };

        if (spec.encoding && spec.encoding.color) {
            spec.encoding.color.scale = {
                domain: ['Actual', 'Projected'],
                range: ['#4a90e2', '#4caf50'],
            };
        }

        const container = document.getElementById('vega-revenue_chart');
        if (container) {
            window.vegaEmbed(container, spec, { actions: false }).catch(console.error);
        }
    } catch (e) {
        console.error('Error rendering Vega chart:', e);
    }
}

export function updateRevenueChart(showProjected) {
    const chartDiv = document.getElementById('chart-revenue_chart');
    if (!chartDiv) return;

    const chartDataJson = chartDiv.getAttribute('data-chart-data');
    const chartSpecJson = chartDiv.getAttribute('data-chart-spec');
    if (!chartDataJson || !chartSpecJson) return;

    try {
        const allData = JSON.parse(chartDataJson);
        const spec = JSON.parse(chartSpecJson);

        const filteredData = showProjected
            ? allData
            : allData.filter(d => d.revenue_type === 'Actual');

        spec.data = { values: filteredData };

        if (spec.encoding && spec.encoding.color) {
            spec.encoding.color.scale = {
                domain: ['Actual', 'Projected'],
                range: ['#4a90e2', '#4caf50'],
            };
        }

        const container = document.getElementById('vega-revenue_chart');
        if (container) {
            container.innerHTML = '';
            window.vegaEmbed(container, spec, { actions: false }).catch(console.error);
        }
    } catch (e) {
        console.error('Error updating chart:', e);
    }
}

export function setupCelebration() {
    const checkbox = document.getElementById('merge-checkbox');
    const celebrationContainer = document.getElementById('celebration-container');

    if (!checkbox || !celebrationContainer) {
        return;
    }

    checkbox.addEventListener('change', function() {
        if (this.checked) {
            celebrationContainer.style.display = 'block';
            startConfetti();
            updateRevenueChart(true);
        } else {
            celebrationContainer.style.display = 'none';
            stopConfetti();
            updateRevenueChart(false);
        }
    });
}

// Monkey-patch of updatePreview that injects celebration setup and Vega rendering.
// Registered in state via setUpdatePreview() so renderViaHTTP uses the patched version.
export function patchedUpdatePreview(content, errors, format = 'html', warnings = []) {
    baseUpdatePreview(content, errors, format, warnings);
    setTimeout(() => {
        setupCelebration();
        if (format === 'html') {
            renderVegaCharts();
            setTimeout(() => scalePreviewContent(), 200);
        }
    }, 100);
}
